import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { AlertController, ToastController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;

  constructor(
    private readonly router       : Router,
    private readonly fb           : FormBuilder,
    private readonly apiProvider  : ApiProviderService,
    private readonly alertCtrl    : AlertController,
    private readonly toastCtrl    : ToastController,
    private readonly userService : UserService
  ) { }

  ngOnInit() {
    let user = this.userService.getUser();

    if(user?.email){
      this.contactForm = this.fb.group({
        Email: [user.email, [Validators.required, Validators.email]],
        Title: ['', Validators.required],
        Description: ['', [Validators.required, Validators.minLength(10)]]
      });
    }else{
      this.contactForm = this.fb.group({
        Email: ['', [Validators.required, Validators.email]],
        Title: ['', Validators.required],
        Description: ['', [Validators.required, Validators.minLength(10)]]
      });
    }
  }

  onSubmit() {
    if (this.contactForm.valid) {
      this.apiProvider.contactUs(this.contactForm.value).subscribe(
        (res) => {
          this.toastCtrl.create({
            message : 'Message envoyé',
            color : 'success'
          });
        },
        async (err) => {
          const alert = await this.alertCtrl.create({
            header: 'Confirmation',
            message: `Une erreur est survenue, veuillez ré-essayer plus tard.`,
            buttons: [
              {
                text: 'Ok'
              }
            ]
          });

          alert.present();
        }
      );
    }
  }

  backClick() {
    this.router.navigateByUrl("/coach/about");
  }
}